/* eslint-disable no-template-curly-in-string */
import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let basicExample = `greet() {
    local name="$\{1:-world}"
    echo "Hello, $name!"
}

greet "Julian"   # Hello, Julian!
greet            # Hello, world!`

let returnExample = `is_even() {
    local n="$1"
    (( n % 2 == 0 ))
}

if is_even 4; then
    echo "even"
fi

# Return actual data by printing and capturing with command substitution
double() {
    echo $(( $1 * 2 ))
}
result=$(double 21)
echo "$result"   # 42`

let recursionExample = `factorial() {
    local n="$1"
    if (( n <= 1 )); then
        echo 1
    else
        echo $(( n * $(factorial $(( n - 1 ))) ))
    fi
}

factorial 5   # 120`

export default function BashFunctions() {
    return (
        <div className={globalStyles.article}>
            <h1>Functions</h1>

            <h3>Arguments & locals</h3>
            <p>Functions receive their own <code>$1</code>, <code>$2</code>, <code>$@</code> and
                <code> $#</code>, separate from the script's — declare variables with <code>local</code> so
                they don't leak into the caller's scope.</p>
            <SyntaxHighlighter
                children={basicExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Inside a function</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>$1</code>, <code>$2</code>, ...</td>
                        <td>Positional arguments</td>
                    </tr>
                    <tr>
                        <td><code>{"$@"}</code></td>
                        <td>All arguments as separate words</td>
                    </tr>
                    <tr>
                        <td><code>$#</code></td>
                        <td>Number of arguments</td>
                    </tr>
                    <tr>
                        <td><code>$FUNCNAME</code></td>
                        <td>Name of the current function</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Exit status vs. return value</h3>
            <p>Bash functions don't return values the way other languages do — a function's <code>return</code>
                (or its last command) only sets its <b>exit status</b> (0-255, checkable via <code>$?</code> or
                directly in an <code>if</code>). To get data back, <code>echo</code> it and capture the output
                with command substitution.</p>
            <SyntaxHighlighter
                children={returnExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Recursion</h3>
            <p>Bash supports recursive functions, though each recursive call spawns a subshell for the
                command substitution — fine for small inputs, not something to reach for at scale.</p>
            <SyntaxHighlighter
                children={recursionExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
